import { CheckCircleIcon } from "lucide-react";
import { Job, JobApplication } from "@type/job";
import { parseFormat } from "@util/date";

interface Props {
    job: Job;
    job_application: JobApplication | undefined;
}

export default function QuickApplyComplete(props: Props) {
    return (
        <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-4 sm:p-8">
            <div className="text-center mb-4 sm:mb-8">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-2 sm:mb-4">
                    <CheckCircleIcon className="w-10 h-10 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold">
                    Application submitted successfully!
                </h2>
                <p className="text-gray-600 mt-2">
                    Your application for <b>{props.job?.job_title}</b> at <b>{props.job?.company_name === props.job?.main_company_name ? props.job?.company_name : `${props.job?.company_name} by ${props.job?.main_company_name}`}</b> has been received.<br />
                    You'll receive updates on your application status via email.
                </p>
            </div>

            <div className="bg-gray-50 rounded-lg p-4 sm:p-6 border border-gray-200">
                <h3 className="text-lg font-medium mb-4">Application Details</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-4 bg-white rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-500">Job Title</p>
                        <p className="font-medium">
                            {props.job_application?.job_title || ""}
                        </p>
                    </div>

                    <div className="p-4 bg-white rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-500">Company</p>
                        <p className="font-medium">
                            {props.job?.company_name === props.job?.main_company_name ? props.job?.company_name : `${props.job?.company_name} by ${props.job?.main_company_name}`}
                        </p>
                    </div>

                    <div className="p-4 bg-white rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-500">Application ID</p>
                        <p className="font-medium">
                            {props.job_application?.applicant_id || ""}
                        </p>
                    </div>

                    <div className="p-4 bg-white rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-500">Applied Date</p>
                        <p className="font-medium">
                            {parseFormat(
                                props.job_application?.created_at || "",
                                "D MMMM YYYY"
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
